import AdminVariantEdit from "./edit";

export default AdminVariantEdit;
